import { PetType } from '@spike/model';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import PetTypeOption from './PetTypeOption';
import styles from './PetTypesSelector.module.scss';

interface PetTypesSelectorProps {
    petTypes: Array<PetType>;
    selectedPetTypeIds: Array<string>;
    onChange?: (petTypesIds: Array<string>) => void;
    className?: string;
}

export const PetTypesSelector: FunctionComponent<PetTypesSelectorProps> = props => {
    const changeHandler = (petTypeId: string, selected: boolean) => {
        const otherSelectedIds = props.selectedPetTypeIds.filter(id => id !== petTypeId);
        props.onChange?.(selected ? [...otherSelectedIds, petTypeId] : otherSelectedIds);
    };

    return (
        <div className={clsx(styles.container, props.className)}>
            {props.petTypes.map(petType => (
                <PetTypeOption
                    key={petType.id}
                    petType={petType}
                    selected={props.selectedPetTypeIds.includes(petType.id)}
                    onChange={selected => changeHandler(petType.id, selected)}
                />
            ))}
        </div>
    );
};

export default PetTypesSelector;
